// services/examService.ts
import { useAuth } from "../contaxt/AuthContext";
import { api } from "./supabaseClient";
import { getSessionId } from "@/utils/storage";
export function useExamApi() {
  const { getPaidUser } = useAuth();

  const getExamList = async () => {
    const paidUser = getPaidUser();
    console.log("🔍 Paid user received in getExamList:", paidUser);

    if (!paidUser) {
      throw new Error("❌ Not a paid user or not authenticated");
    }

    const { userId, token } = paidUser;

    const { data } = await api.post(
      "/functions/v1/exam-list",
      { user_id: userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (data?.exams) {
      data.exams = data.exams.filter(
        (exam: any) => exam.feedback_json != null
      );
    }

    return data;
  };

  const getExamListDashboard = async () => {
    const paidUser = getPaidUser();
    console.log("🔍 Paid user received in getExamListDashboard:", paidUser);

    if (!paidUser) {
      throw new Error("❌ Not a paid user or not authenticated");
    }

    const { userId, token } = paidUser;

    const { data } = await api.post(
      "/functions/v1/dashboard-examlist",
      { user_id: userId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (data?.exams) {
      data.exams = data.exams.filter(
        (exam: any) => exam.feedback_json != null
      );
    }

    return data;
  };

  // ✅ Return BOTH functions
  return { getExamList, getExamListDashboard };
}


export async function getExamDetailsApi(paidUser: { userId: string; token: string }, sessionId: string) {
  const { userId, token } = paidUser;
  const { data } = await api.post(
    "/functions/v1/exam-detail",
    {
      user_id: userId,
      exam_id: sessionId,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
}

export async function TaskAttemptDetail(params: { 
  sessionId: string; 
  token: string; 
  userId: string; 
  id: string; 
}) {
  const { sessionId, token, userId, id } = params;

  try {
    const { data } = await api.post(
      "/functions/v1/task-attempt-detail",
      {
        user_id: userId,
        exam_id: String(sessionId),
        id, 
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return data;
  } catch (error: any) {
    console.error("❌ TaskAttemptDetail API error:", error.response || error.message);
    return { success: false, message: error.message };
  }
}
